const defaultConfig = {
  internalResolution: "medium",
  segmentationThreshold: 0.7,
};

export const isiOSSafari = false; // iOS && webkit && !ua.match(/CriOS/i);

export const loadDeviceConfigs = () => defaultConfig;
